module.exports = __webpack_public_path__ + "static/media/addMemberIcon.d45ddc7c.svg";